import React, {useState} from 'react';
import {SummaryComponent} from './components/Common/SummaryComponent';
import {VexWorkbenchList} from './components/VexWorkbench/VexWorkbenchList';
import {KeywordStatus} from 'types';
import {WorkbenchRequirementsList} from './components/VexWorkbench/WorkbenchRequirementsList';
import {useUserContext} from 'authentication/UserContext';
import {useTheme, Text, Stack} from '@fluentui/react';
import {
	BaseWorkBenchComponent,
	getDashboardClassNames,
	stackItemStyles,
} from './components/Common/BaseWorkBenchComponent';
import {useTranslation} from 'react-i18next';

export const DashboardPageVexPart = () => {
	const theme = useTheme();
	const classNames = getDashboardClassNames(theme);
	const {
		isVex,
		isVexSupport,
		isVko,
		isAdmin,
		isApprover,
		isVkoExternal,
		isServiceProvider,
		isReader,
		isBedarfskoordinator,
	} = useUserContext();

	const {t} = useTranslation('features/dashboard', {
		keyPrefix: 'DashboardPage',
	});

	const [vexRequirementCount, setVexRequirementCount] = useState<
		number | undefined
	>(undefined);

	// Don't show "In Assessment" list for VEX Support users
	const renderVexWorkbenchLists = () => (
		<>
			{!isVexSupport && (
				<VexWorkbenchList halfHeight keywordStatus={KeywordStatus.New} />
			)}
			<VexWorkbenchList halfHeight keywordStatus={KeywordStatus.Accepted} />
			<VexWorkbenchList halfHeight keywordStatus={KeywordStatus.Finalized} />
		</>
	);
	return (
		<>
			{isVex && <SummaryComponent requirementCount={vexRequirementCount} />}
			{isVex && (
				<Stack horizontalAlign='start' className={classNames.WorkbenchHeader}>
					<Text className={classNames.WorkbenchHeaderText}>
						{t('RegulationsOverviewHeader')}
					</Text>
				</Stack>
			)}
			<Stack horizontal horizontalAlign='start'>
				{isVex || isApprover ? (
					<Stack horizontal styles={{root: {width: '100%'}}} grow={1}>
						{isVex && renderVexWorkbenchLists()}
					</Stack>
				) : (
					<BaseWorkBenchComponent
						isVkoExternal={isVkoExternal}
						isVko={isVko}
						isAdmin={isAdmin}
						isReader={isReader}
						isServiceProvider={isServiceProvider}
						isBedarfskoordinator={isBedarfskoordinator}
						stackItemStyles={stackItemStyles}
					/>
				)}
			</Stack>

			{isVex && (
				<Stack horizontalAlign='start' className={classNames.WorkbenchHeader}>
					<Text className={classNames.WorkbenchHeaderText}>
						{t('ReqsOverviewHeader')}
					</Text>
				</Stack>
			)}
			{isVex && (
				<Stack
					horizontal
					horizontalAlign='start'
					styles={{root: {width: '100%', overflowX: 'hidden'}}}
					grow={1}
				>
					<WorkbenchRequirementsList
						halfHeight
						itemCountLoaded={(count: number) => setVexRequirementCount(count)}
					/>
				</Stack>
			)}
		</>
	);
};
